import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import { InvoiceInboxSettings } from "./invoiceInbox/InvoiceInboxSettings";
import { AssignmentAndVisaSettings } from "./assignmentAndVisa/AssignmentAndVisaSettings";
import styles from "src/screens/communicationSettings/CommunicationSettings.module.css";

const KrediFlowCommunicationSettingsBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const { communicationSettingsStore } = useContext(RootStoreContext);

    const onSave = async () => {
        await communicationSettingsStore.saveKrediFlowSettings();
    };

    const onDiscard = () => {
        communicationSettingsStore.resetKrediFlowSettings();
    };

    const saveSettingsButtonLabel = (
        <div className="d-flex align-items-center">
            <div>{t("labels.save")}</div>
            <UI.RotatingSpinner
                className={`${styles.SaveButtonSpinner} ${
                    communicationSettingsStore.isLoadingKrediFlowSettings ? "" : "d-none"
                }`}
                noLogo={true}
                size={20}
            />
        </div>
    );

    return (
        <React.Fragment>
            <InvoiceInboxSettings />
            <AssignmentAndVisaSettings />
            <UI.Row>
                <UI.Col xl={9}></UI.Col>
                <UI.Col xl={3} className="d-flex justify-content-end align-items-center">
                    <UI.Button
                        onClick={onSave}
                        label={saveSettingsButtonLabel}
                        disabled={
                            communicationSettingsStore.isLoadingKrediFlowSettings ||
                            !communicationSettingsStore.hasKrediFlowSettingsChanged ||
                            communicationSettingsStore.hasKrediFlowValidationErrors
                        }
                    />
                    <UI.Button
                        label={t("labels.discard")}
                        disabled={!communicationSettingsStore.hasKrediFlowSettingsChanged}
                        onClick={onDiscard}
                        className={"ml-2"}
                        variant="outline-primary"
                    />
                </UI.Col>
            </UI.Row>
        </React.Fragment>
    );
};

export const KrediFlowCommunicationSettings = withRouter(
    Sentry.withProfiler(observer(KrediFlowCommunicationSettingsBase))
);
